import { intl } from "@/helpers";

export default {
  responsive: true,
  legend: {
    display: true,
    position: "top",
    labels: {
      generateLabels(chart) {
        return chart.data.datasets.map((d, i) => {
          const managerTotal = intl.formatNumberRu(
            Math.round(d.meta.total / 1000)
          );
          return {
            text: `${d.label}: ${managerTotal} тис. грн ${
              d.meta.percentage
                ? "(" + d.meta.percentage.toFixed(1) + " %)"
                : ""
            }`,
            fillStyle: d.backgroundColor,
            index: i,
          };
        });
      },
    },
    onClick(e, legendItem) {
      const index = legendItem.index;
      const meta = this.chart.getDatasetMeta(index);
      meta.hidden = !meta.hidden
        ? !this.chart.data.datasets[index].hidden
        : null;
      this.chart.update();
    },
  },
  tooltips: {
    callbacks: {
      label(tooltipItem, data) {
        const datasetItem = data.datasets[tooltipItem.datasetIndex];
        const itemValue = intl.formatNumberRu(
          Math.round(tooltipItem.value / 1000)
        );
        const totalValue = intl.formatNumberRu(
          Math.round(datasetItem.meta.total / 1000)
        );
        return `${datasetItem.label}: ${itemValue} тис. грн (ітого ${totalValue} тис. грн)`;
      },
    },
  },
  scales: {
    yAxes: [
      {
        id: "A",
        type: "linear",
        position: "left",
        ticks: {
          callback(value) {
            const yAxisValue = intl.formatNumberRu(
              Math.round(value / 1000)
            );
            return `${yAxisValue} тис. грн`;
          },
        },
      },
    ],
  },
};